
import { Typography } from "antd";
import { Chart } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { useEffect, useRef } from "react";
import { ChartValueType } from "../../../../../../../constants/constants";
import { AMOUNT_UTIL } from "../../../../../../../utils/amount.utils";

export interface FrontierChartData {
    label: string,
    data: any[],
    backgroundColor: string
}

interface Props {
    data: FrontierChartData[];
    title: string;
    labels: string[],
    chartId: string;
    valueType?: ChartValueType;
}

const ChartFont = {
    size: 10,
    family: "'Roboto', sans-serif"
}


const FrontierChart = (props: Props) => {

    let chart = useRef<Chart>();
    const forceUpdate = React.useReducer(() => ({}), {})[1] as () => void

    const getChartData = (): any => {
        const datasets: any[] = [];
        props.data.forEach((x, index) => {
            datasets.push({
                label: x.label,
                data: x.data,
                backgroundColor: x.backgroundColor,
                stack: `Stack ${index}`,
                yAxisID: 'y',
                datalabels: {
                    display: false
                }

            })
        });


        return {
            labels: props.labels,
            datasets: datasets
        }
    }

    const lengendClick = (label: string) => {

        if (chart.current) {
            chart.current.data.datasets.forEach(dataset => {
                if (dataset.label === label) {
                    dataset.hidden = !dataset.hidden;
                }
            });

            chart.current.update();
            forceUpdate();
        }

    }

    const inintChart = () => {

        const element: any = document.getElementById(props.chartId);
        const ctx = element.getContext('2d');
        const chartData = getChartData();


        chart.current = new Chart(ctx, {
            type: 'bar',
            data: chartData,
            plugins: [ChartDataLabels],
            options: {
                responsive: false,
                scales: {
                    y: {
                        position: 'left',
                        beginAtZero: true,
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: function (value, index, values) {
                                switch (props.valueType) {
                                    case ChartValueType.Percent:
                                        return AMOUNT_UTIL.converNumberToPercentage(Number(value));
                                    case ChartValueType.Currency:
                                        return AMOUNT_UTIL.convertNumericToFormattedAmount(Number(value));
                                    default:
                                        return value;
                                }

                            },
                            font: ChartFont,
                            color: "#969696"
                        }
                    },
                    x: {
                        ticks: {
                            font: ChartFont,
                            color: "#969696"
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                }
            },
        });

        forceUpdate();
    }

    const updateChart = () => {
        if (chart.current) {
            const chartData = getChartData();
            chart.current.data = chartData;
            chart.current.update();
            forceUpdate();
        }
    }

    useEffect(() => {
        if (props.data && props.data.length) {
            if (chart.current) {
                updateChart();
            } else {
                inintChart();
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data])

    return (
        <div className="chart-wrapper">
            <h4>
                {props.title}
            </h4>
            <canvas height={300} id={props.chartId}></canvas>
            <div className="chart-legend">
                {
                    chart.current?.data.datasets.map((item: any) => {

                        return (
                            <div key={item.label} className="legend-item" onClick={() => lengendClick(item.label)}>
                                <div className="line" style={{ backgroundColor: item.backgroundColor?.toString() }}>
                                </div>
                                <Typography.Text delete={item.hidden}>
                                    {item.label}
                                </Typography.Text>

                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}


export default React.memo(FrontierChart)
